import { render, staticRenderFns } from "./Soumission.vue?vue&type=template&id=9fcddbdc"
import script from "./Soumission.vue?vue&type=script&lang=js"
export * from "./Soumission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports